import { createSlice } from "@reduxjs/toolkit";
import { toCamel } from "../../utils/helpers";
import {
  getCategoryOptionsApi,
  getCitiesOptionsApi,
  getEmiratesOptionsApi,
  getStatusOptionsApi,
  getCivilDefenseContractApprovalStatusApi,
  getContractTypesApi,
  getContractStatusesApi,
  getSystemsAPI,
  getServiceTerritoriesApi,
  getOnHoldReasonApi,
  getAppointmentTypesAPI,
  getAssignedBuildingsAPI,
  getAppointmentsOnHoldReasonApi,
  getAppointmentsStatusesApi,
  getApprovalTypesApi,
  getBuildingsForInvoicesApi,
  getCDUCitiesApi,
  getBuildRequestStatusesApi,
} from "src/api/lookupApi";
import { Languages } from "src/resources/enum";
import { handleResponse } from "src/services/apiServices";
import {
  CONSOLIDATED_PAYMENT_OPTIONS,
  INVOICE_PAYMENT_OPTIONS,
} from "src/resources/constant";
import { trackPromise } from "react-promise-tracker";

export const getStatusOptions = () => {
  return async (dispatch: any, getState: any) => {
    await getStatusOptionsApi().then((response) => {
      dispatch(setStatusOptions(toCamel(response.data.OptionSetItems)) as any);
    });
  };
};
export const getInvoiceStatusOptions = () => {
  return async (dispatch: any, getState: any) => {
    dispatch(setInvoiceStatusOptions(INVOICE_PAYMENT_OPTIONS));
  };
};

export const getAppointmentTypes = () => {
  return async (dispatch: any, getState: any) => {
    await getAppointmentTypesAPI().then((res) => {
      dispatch(setAppointmentTypes(toCamel(res.data.OptionSetItems)) as any);
    });
  };
};
export const getCategoryOptions = () => {
  return async (dispatch: any, getState: any) => {
    await getCategoryOptionsApi().then((res) => {
      dispatch(
        setCategoryOptions(toCamel(res.data.OptionSetItems || [])) as any
      );
    });
  };
};

export const getSystems = () => {
  return async (dispatch: any, getState: any) => {
    await getSystemsAPI().then((res) => {
      dispatch(setSystems(toCamel(res.data)) as any);
      return res;
    });
  };
};

export const getContractTypes = () => {
  return async (dispatch: any, getState: any) => {
    await getContractTypesApi().then((res) => {
      dispatch(setContractTypes(toCamel(res.data.OptionSetItems || [])) as any);
    });
  };
};

export const getContractStatuses = () => {
  return async (dispatch: any, getState: any) => {
    await getContractStatusesApi().then((res) => {
      dispatch(
        setContractStatues(toCamel(res.data.OptionSetItems || [])) as any
      );
    });
  };
};

export const getCivilDefenseContractApprovalStatus = () => {
  return async (dispatch: any, getState: any) => {
    await getCivilDefenseContractApprovalStatusApi().then((res) => {
      dispatch(
        setCivilDefenseContractApprovalStatuses(
          toCamel(res.data.OptionSetItems || [])
        ) as any
      );
    });
  };
};

export const getEmiratesOptions = () => {
  return async (dispatch: any, getState: any) => {
    await getEmiratesOptionsApi().then((res: any) => {
      dispatch(setEmiratesOptions(toCamel(res?.data?.Emirates || [])));
    });
  };
};

export const getServiceTerritories = (
  isRetrieveByBuilding?: boolean,
  cityId?: any
) => {
  const retrieveByBuilding = isRetrieveByBuilding ?? true;

  return async (dispatch: any) => {
    trackPromise(
      getServiceTerritoriesApi(retrieveByBuilding, cityId)
        .then((res: any) => {
          if (cityId !== "") {
            dispatch(setServiceTerritories(toCamel(res?.data)));
          } else {
            dispatch(setAllServiceTerritories(toCamel(res?.data)));
          }
        })
        .then((res) => {
          handleResponse(res, Languages.English);
        })
        .catch((err) => {
          handleResponse(err, Languages.English);
        })
    );
  };
};

export const getOnHoldReasons = () => {
  return async (dispatch: any) => {
    await getOnHoldReasonApi().then((res: any) => {
      dispatch(setOnHoldReasons(toCamel(res?.data)));
    });
  };
};
export const getBuildingsForInvoices = () => {
  return async (dispatch: any) => {
    await getBuildingsForInvoicesApi().then((res: any) => {
      dispatch(setBuildingsForInvoices(toCamel(res?.data)));
    });
  };
};

export const getAssignedBuildingsLookup = () => {
  return async (dispatch: any) => {
    await getAssignedBuildingsAPI().then((res: any) => {
      dispatch(toCamel(setAssignedBuildings(res?.data)));
    });
  };
};

export const getCitiesOptions = (
  emirateId: "bbfaefd1-1f21-e811-910c-00505686c522"
) => {
  return async (dispatch: any, getState: any) => {
    await getCitiesOptionsApi(emirateId).then((res: any) => {
      dispatch(setCitiesOptions(toCamel(res?.data?.Cities || [])));
    });
  };
};

export const getCDUCities = () => {
  return async (dispatch: any, getState: any) => {
    await getCDUCitiesApi().then((res: any) => {
      dispatch(setCitiesOptions(toCamel(res?.data?.Cities || [])));
    });
  };
};

export const getAppointmentsOnHoldReason = () => {
  return async (dispatch: any) => {
    await getAppointmentsOnHoldReasonApi().then((res: any) => {
      dispatch(
        setAppointmentsOnHoldReason(toCamel(res.data.OptionSetItems || []))
      );
    });
  };
};

export const getAppointmentsStatuses = () => {
  return async (dispatch: any, getState: any) => {
    await getAppointmentsStatusesApi().then((res: any) => {
      dispatch(
        setAppointmentsStatuses(
          toCamel(
            (res.data.OptionSetItems?.filter(
              (status: { EnglishName?: string }) =>
                status.EnglishName?.toLowerCase() !== "unassigned"
            ) || []) as any[]
          )
        )
      );
    });
  };
};

export const getApprovalTypes = () => {
  return async (dispatch: any, getState: any) => {
    await getApprovalTypesApi().then((res: any) => {
      dispatch(setApprovalTypes(toCamel(res.data.OptionSetItems || [])));
    });
  };
};

// new action for getBuildRequestStatusesApi

export const getBuildRequestStatuses = () => {
  return async (dispatch: any, getState: any) => {
    await getBuildRequestStatusesApi().then((res: any) => {
      dispatch(setBuildRequestStatuses(toCamel(res.data.OptionSetItems || [])));
    });
  };
};

const initialState = {
  allServiceTerritories: [],
  systemNameOptions: [],
  statusOptions: [],
  invoiceStatusOptions: [],
  consolidatedInvoiceStatusOptions: [...CONSOLIDATED_PAYMENT_OPTIONS],
  contractTypes: [],
  contractStatuses: [],
  systems: [],
  civilDefenseContractApprovalStatuses: [],
  categoryOptions: [],
  emiratesOptions: [],
  citiesOptions: [],
  serviceTerritories: [],
  assignedBuildings: [],
  onHoldReasons: [],
  buildingsForInvoices: [],
  appointmentTypes: [],
  appointmentsOnHoldReason: [],
  appointmentsStatuses: [],
  approvalTypes: [],
  paymentInitiator: "",
  paymentDetails: {
    invoiceId: "",
    paidAmount: 0,
    paymentDateAndTime: "",
  },
  buildingRequestStatuses: [],
  language: Languages.English,
};

const lookupSlice = createSlice({
  name: "lookup",
  initialState,
  reducers: {
    setAllServiceTerritories: (state, action) => {
      state.allServiceTerritories = action.payload;
    },
    setStatusOptions: (state, action) => {
      state.statusOptions = action.payload;
    },
    setInvoiceStatusOptions: (state, action) => {
      state.invoiceStatusOptions = action.payload;
    },
    setConsolidatedInvoiceStatusOptions: (state, action) => {
      state.consolidatedInvoiceStatusOptions = action.payload;
    },
    setAppointmentTypes: (state, action) => {
      state.appointmentTypes = action.payload;
    },
    setCategoryOptions: (state, action) => {
      state.categoryOptions = action.payload;
    },
    setContractTypes: (state, action) => {
      state.contractTypes = action.payload;
    },
    setContractStatues: (state, action) => {
      state.contractStatuses = action.payload;
    },
    setSystems: (state, action) => {
      state.systems = action.payload;
    },
    setCivilDefenseContractApprovalStatuses: (state, action) => {
      state.civilDefenseContractApprovalStatuses = action.payload;
    },
    setEmiratesOptions: (state, action) => {
      state.emiratesOptions = action.payload;
    },
    setServiceTerritories: (state, action) => {
      state.serviceTerritories = action.payload;
    },

    setOnHoldReasons: (state, action) => {
      state.onHoldReasons = action.payload;
    },
    setBuildingsForInvoices: (state, action) => {
      state.buildingsForInvoices = action.payload;
    },
    setAssignedBuildings: (state, action) => {
      state.assignedBuildings = action.payload;
    },
    setCitiesOptions: (state, action) => {
      state.citiesOptions = action.payload;
    },

    setAppointmentsOnHoldReason: (state, action) => {
      state.appointmentsOnHoldReason = action.payload;
    },

    setAppointmentsStatuses: (state, action) => {
      state.appointmentsStatuses = action.payload;
    },

    setApprovalTypes: (state, action) => {
      state.approvalTypes = action.payload;
    },

    setBuildRequestStatuses: (state, action) => {
      state.buildingRequestStatuses = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setPaymentInitiator: (state, action) => {
      state.paymentInitiator = action.payload;
    },
    setPaymentDetails: (state, action) => {
      state.paymentDetails = action.payload;
    },
  },
});
export const {
  setAllServiceTerritories,
  setStatusOptions,
  setInvoiceStatusOptions,
  setCategoryOptions,
  setEmiratesOptions,
  setSystems,
  setCivilDefenseContractApprovalStatuses,
  setContractTypes,
  setContractStatues,
  setCitiesOptions,
  setOnHoldReasons,
  setBuildingsForInvoices,
  setServiceTerritories,
  setLanguage,
  setAppointmentTypes,
  setAppointmentsOnHoldReason,
  setAppointmentsStatuses,
  setBuildRequestStatuses,
  setPaymentInitiator,
  setAssignedBuildings,
  setConsolidatedInvoiceStatusOptions,
  setApprovalTypes,
  setPaymentDetails,
} = lookupSlice.actions;

export default lookupSlice.reducer;
